import { LinkifiedJSON } from '#components/patterns/linkified-json/LinkifiedJSON.tsx';
import type { AuditLog } from '#dn-types/audit-log.ts';
import styles from './AuditLogDiff.module.css';

type Props = {
  log: AuditLog;
};

export function AuditLogDiff({ log }: Props) {
  return (
    <div className={styles.AuditLogDiff}>
      <div className={styles.AuditLogDiff_actor}>
        <h4 className="eyebrow m-0">Actor:</h4>
        <LinkifiedJSON data={log.actor} allowScroll={true} />
      </div>
      <div className={styles.AuditLogDiff_target}>
        <h4 className="eyebrow m-0">Target:</h4>
        <LinkifiedJSON data={log.target} allowScroll={true} />
      </div>
      <div className={styles.AuditLogDiff_side}>
        <h4 className="eyebrow m-0">Before:</h4>
        <LinkifiedJSON data={log.event.before} allowScroll={true} />
      </div>
      <div className={styles.AuditLogDiff_side}>
        <h4 className="eyebrow m-0">After:</h4>
        <LinkifiedJSON data={log.event.after} allowScroll={true} />
      </div>
    </div>
  );
}
